'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _FormControl = require('react-bootstrap/lib/FormControl');

var _FormControl2 = _interopRequireDefault(_FormControl);

var _InputWrapper = require('../internal/InputWrapper');

var _InputWrapper2 = _interopRequireDefault(_InputWrapper);

var _reactTextMask = require('react-text-mask');

var _reactTextMask2 = _interopRequireDefault(_reactTextMask);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/** Text input that enforces consistency in validation, required field marker, and labels.
 * If you require an input for specific information, consider using one of the following specialized inputs:
 * - [NumericInput](/components/NumericInput)
 * - [PhoneInput](/components/PhoneInput)
 * - [PostalCodeInput](/components/PostalCodeInput)
 * - [PriceInput](/components/PriceInput)
 * - [EmailInput](/components/EmailInput)
 * - [VinNumberInput](/components/VinNumberInput)
 * - [DatePicker](/components/DatePicker)
 * - [TimePicker](/components/TimePicker)
 */

var TextInput = function (_Component) {
  _inherits(TextInput, _Component);

  function TextInput(props) {
    _classCallCheck(this, TextInput);

    var _this = _possibleConstructorReturn(this, (TextInput.__proto__ || Object.getPrototypeOf(TextInput)).call(this, props));

    _this.componentDidMount = function () {
      var _this$props = _this.props,
          error = _this$props.error,
          label = _this$props.label,
          name = _this$props.name,
          onChange = _this$props.onChange,
          value = _this$props.value,
          warning = _this$props.warning;

      var warningOnMount = _this.getWarning(label, value, warning);
      var isValid = !error;

      _this.setState({
        repressError: !error && !warningOnMount,
        error: error,
        warning: warningOnMount,
        isValid: isValid
      }, function () {
        onChange({ target: { name: name, value: _this.prepareReturnedValue(value) } }, isValid);
      });
    };

    _this.getError = function (label, value, errorFromParent) {
      var _this$props2 = _this.props,
          maxLength = _this$props2.maxLength,
          minLength = _this$props2.minLength,
          getError = _this$props2.getError,
          required = _this$props2.required;
      var maskedMaxLength = _this.props.masking.maskedMaxLength;

      var errorFromCustomValidator = getError ? getError(label, value) : '';

      if (errorFromParent) {
        return errorFromParent;
      } else if (errorFromCustomValidator) {
        return errorFromCustomValidator;
      } else if (required && !value) {
        return label + ' is Required';
      } else if (minLength && value.length < minLength) {
        return minLength + ' ' + (minLength > 1 ? 'Characters' : 'Character') + ' Required';
      } else if (maxLength && value.length > maxLength) {
        if (maskedMaxLength && _this.unmask(value).length > maskedMaxLength) {
          return '\'' + value + '\', Exceeds Character Limit of ' + maskedMaxLength;
        } else {
          return 'Value Exceeds ' + maxLength + ' Character Limit';
        }
      } else {
        return '';
      }
    };

    _this.getWarning = function (label, value, warningFromParent) {
      var _this$props3 = _this.props,
          maxLength = _this$props3.maxLength,
          minLength = _this$props3.minLength,
          getWarning = _this$props3.getWarning,
          required = _this$props3.required;
      var maskedMaxLength = _this.props.masking.maskedMaxLength;

      var warningFromCustomValidator = getWarning ? getWarning(label, value) : '';

      if (warningFromParent) {
        return warningFromParent;
      } else if (warningFromCustomValidator) {
        return warningFromCustomValidator;
      } else if (_this.state.repressError) {
        return '';
      } else if (required && !value) {
        return 'Received Empty Value on Required Field';
      } else if (minLength && value.length < minLength) {
        return minLength + ' ' + (minLength > 1 ? 'Characters' : 'Character') + ' Required';
      } else if (maxLength && value.length > maxLength) {
        if (maskedMaxLength && _this.unmask(value).length > maskedMaxLength) {
          return '\'' + value + '\', Exceeds Character Limit of ' + maskedMaxLength;
        } else {
          return 'Received Value Exceeds ' + maxLength + ' Character Limit';
        }
      } else {
        return '';
      }
    };

    _this.getValidationState = function () {
      var shouldShowError = _this.shouldShowError();
      var shouldShowWarning = _this.shouldShowWarning();

      if (shouldShowError) {
        return 'error';
      } else if (shouldShowWarning) {
        return 'warning';
      } else {
        return null;
      }
    };

    _this.shouldShowError = function () {
      var _this$state = _this.state,
          repressError = _this$state.repressError,
          error = _this$state.error,
          isValid = _this$state.isValid;


      if (_this.props.error) {
        return true;
      } else if (error && isValid) {
        return false;
      } else if (error && repressError) {
        return false;
      } else if (error) {
        return true;
      } else {
        return false;
      }
    };

    _this.shouldShowWarning = function () {
      var value = _this.props.value;
      var _this$state2 = _this.state,
          warning = _this$state2.warning,
          isFocused = _this$state2.isFocused,
          isValid = _this$state2.isValid;

      var valueHasChanged = _this.outgoingValue !== value;

      if (_this.props.warning) {
        return true;
      } else if (warning && !isValid) {
        return false;
      } else if (warning && isFocused && valueHasChanged) {
        return false;
      } else if (warning) {
        return true;
      } else {
        return false;
      }
    };

    _this.onBlur = function (event) {
      !_this.state.warning && _this.onTextInputChange(event);
      _this.setState({
        repressError: false,
        isFocused: false
      });
      if (_this.props.onBlur) {
        _this.props.onBlur(event);
      }
    };

    _this.onKeyDown = function (event) {
      var onKeyDown = _this.props.onKeyDown;

      if (!onKeyDown) return;
      onKeyDown(event);
    };

    _this.onFocus = function () {
      _this.setState({
        isFocused: true
      });
      if (_this.props.onFocus) {
        _this.props.onFocus();
      }
    };

    _this.onTextInputChange = function (event) {
      var value = _this.prepareReturnedValue(event.target.value);
      var _this$props4 = _this.props,
          label = _this$props4.label,
          name = _this$props4.name,
          onChange = _this$props4.onChange;


      _this.outgoingValue = value;
      var error = _this.getError(label, value, _this.props.error);
      var warning = _this.shouldShowWarning() ? _this.getWarning(label, value, _this.props.warning) : '';
      var isValid = !error || !!warning;

      onChange({ target: { name: name, value: value } }, isValid);
      _this.setState({
        error: error,
        warning: warning,
        isValid: isValid
      });
    };

    _this.setCursorPosition = function (event) {
      // Allows for content to be added to incomplete masked value when cursor is
      // placed after the placeholders '_', otherwise the field is unresponsive.
      var _this$props5 = _this.props,
          maxLength = _this$props5.maxLength,
          masking = _this$props5.masking;
      var _event$target = event.target,
          selectionDirection = _event$target.selectionDirection,
          selectionEnd = _event$target.selectionEnd,
          selectionStart = _event$target.selectionStart,
          value = _event$target.value;

      if (masking.mask && selectionDirection === 'forward' && selectionStart === maxLength && selectionEnd === maxLength && value.endsWith('_')) {
        var countNonEssential = value.match(/_/g, '').length;

        event.target.selectionStart = selectionStart - countNonEssential;
        event.target.selectionEnd = selectionEnd - countNonEssential;
      }
      _this.onKeyDown(event);
      return event;
    };

    _this.prepareReturnedValue = function (value) {
      var mask = _this.props.masking.mask;

      return mask ? _this.unmask(value) : value;
    };

    _this.unmask = function (value) {
      var _this$props$masking = _this.props.masking,
          mask = _this$props$masking.mask,
          unmask = _this$props$masking.unmask;

      var unmaskRegExp = new RegExp('[' + unmask.join('') + ']', 'g');
      var cleanValue = value.toString().replace(unmaskRegExp, '');
      if (typeof value === 'number') {
        cleanValue = Number(cleanValue);
      }

      return mask ? cleanValue : value;
    };

    _this.getInputComponent = function () {
      var mask = _this.props.masking.mask;

      if (mask) {
        return _this.maskedTextInput();
      } else {
        return _this.basicTextInput();
      }
    };

    _this.basicTextInput = function () {
      var _this$props6 = _this.props,
          disabled = _this$props6.disabled,
          htmlId = _this$props6.htmlId,
          label = _this$props6.label,
          onKeyDown = _this$props6.onKeyDown,
          maxLength = _this$props6.maxLength,
          placeholder = _this$props6.placeholder,
          required = _this$props6.required,
          type = _this$props6.type,
          value = _this$props6.value;
      // We disable the maxLength by setting it to null if the value provided exceeds the maxLength.
      // This assures that the initial value passed is populated in the TextInput instead of being truncated.
      // We display an error message when an initial value is passed that exceeds the maxLength.

      var getMaxLength = maxLength && value.length <= maxLength ? maxLength : null;
      return _react2.default.createElement(_FormControl2.default, {
        componentClass: type === 'textarea' ? type : 'input',
        className: htmlId + '-textInput',
        disabled: disabled,
        onChange: _this.onTextInputChange,
        onBlur: _this.onBlur,
        onKeyDown: onKeyDown,
        onFocus: _this.onFocus,
        maxLength: getMaxLength,
        placeholder: placeholder ? placeholder : 'Enter ' + label,
        required: required,
        type: type || 'text',
        value: value
      });
    };

    _this.maskedTextInput = function () {
      var _this$props7 = _this.props,
          disabled = _this$props7.disabled,
          htmlId = _this$props7.htmlId,
          label = _this$props7.label,
          placeholder = _this$props7.placeholder,
          required = _this$props7.required,
          type = _this$props7.type,
          value = _this$props7.value;
      var _this$props$masking2 = _this.props.masking,
          guide = _this$props$masking2.guide,
          mask = _this$props$masking2.mask,
          pipe = _this$props$masking2.pipe;

      return _react2.default.createElement(_reactTextMask2.default, {
        className: 'form-control ' + htmlId + '-maskedInput',
        disabled: disabled,
        guide: guide,
        id: htmlId + '-maskedInput',
        mask: mask,
        pipe: pipe,
        onBlur: _this.onBlur,
        onChange: _this.onTextInputChange,
        onFocus: _this.onFocus,
        onKeyDown: _this.setCursorPosition,
        placeholder: placeholder ? placeholder : 'Enter ' + label,
        required: required,
        type: type || 'text',
        value: value
      });
    };

    _this.outgoingValue = props.value;
    _this.state = {
      repressError: true,
      isFocused: false,
      isValid: true,
      error: '',
      warning: ''
    };
    return _this;
  }

  _createClass(TextInput, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps !== this.props) {
        var label = nextProps.label,
            name = nextProps.name,
            onChange = nextProps.onChange,
            value = nextProps.value,
            error = nextProps.error,
            warning = nextProps.warning;

        // We keep track of the outgoingValue to ensure it comes back through,
        // if not we treat it as a new initial value.
        // This is to differentiate between values updated by this component and new values passed to it.
        // This allows us to display an initial warning instead of an error when a new initial value is provided.

        var treatValueAsNew = this.outgoingValue !== value;
        var errorWarningOrLabelHaveChanged = error !== this.props.error || label !== this.props.label || warning !== this.props.warning;

        if (treatValueAsNew) {
          var errorOnUpdate = this.getError(label, value, error);
          var warningOnUpdate = this.getWarning(label, value, warning);
          this.outgoingValue = value;
          var isValid = !error;
          onChange({ target: { name: name, value: this.prepareReturnedValue(value) } }, isValid);
          this.setState({
            repressError: !warningOnUpdate && !errorOnUpdate,
            error: errorOnUpdate,
            warning: warningOnUpdate,
            isValid: isValid
          });
        } else if (errorWarningOrLabelHaveChanged) {
          var _isValid = !error;
          onChange({ target: { name: name, value: this.prepareReturnedValue(value) } }, _isValid);
          this.setState({
            error: error || '',
            warning: warning || '',
            isValid: _isValid
          });
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var props = _objectWithoutProperties(this.props, []);

      var validationState = this.getValidationState();
      var formControl = this.getInputComponent(this.props.value);

      return _react2.default.createElement(_InputWrapper2.default, Object.assign({}, Object.assign({
        formControl: formControl,
        validationState: validationState
      }, props), {
        helpBlockMessage: this.state[validationState]
      }));
    }
  }]);

  return TextInput;
}(_react.Component);

TextInput.propTypes = {
  /** Defines placement of button or addon child within formgroup. */
  addOnPosition: _propTypes2.default.oneOf(['append', 'prepend']),

  /** Any children to be passed through. */
  children: _propTypes2.default.node,

  /** Additional class name. */
  className: _propTypes2.default.string,

  /** Set to true to disable the TextInput. */
  disabled: _propTypes2.default.bool,

  /** Boolean displays label if set to true. */
  displayLabel: _propTypes2.default.bool,

  /** String to display as error. Overrides standard error and warning handling. */
  error: _propTypes2.default.string,

  /** Function to pass custom error rules to, handy for specific input types. For an implementation example, review the source code of PriceInput. */
  getError: _propTypes2.default.func,

  /** Function to pass custom warning rules to, handy for specific input types. For an implementation example, review the source code of PriceInput. */
  getWarning: _propTypes2.default.func,

  /** Globally unique and descriptive HTML ID. Used by QA for automated testing. */
  htmlId: _propTypes2.default.string.isRequired,

  /** Input label. */
  label: _propTypes2.default.string.isRequired,

  /** **Note:** Before using this prop, consider using one of the specialized inputs listed at the top of this page.
   * Object that determines masking rules for TextInput.
   * [react-text-mask](https://github.com/text-mask/text-mask/blob/master/componentDocumentation.md) is being used for masking.
   * The guide, mask and pipe props all function as described in the [react-text-mask](https://github.com/text-mask/text-mask/blob/master/componentDocumentation.md) documentation.
  *
  - guide: Boolean shows an underscore as placeholder character when field is empty.
  - mask: Mask template for input.  Accepts an array of characters to mask against or a masking function.
  The existence of this property determines whether masking will be used.
    - pipe: Function that allows you to modify the value entered. Examples: Capitalize a letter. Add a leading zero to a number.
  - maskedMaxLength: Expected maxLength of value you wish to return. Accepts number value.
  - unmask: Array of characters to strip out when returning a masked value.<br/>
  */

  masking: _propTypes2.default.shape({
    guide: _propTypes2.default.bool,
    mask: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.func, _propTypes2.default.shape({
      mask: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.func]),
      pipe: _propTypes2.default.func
    })]),
    maskedMaxLength: _propTypes2.default.number,
    pipe: _propTypes2.default.func,
    unmask: _propTypes2.default.array
  }),

  /** Maximum length of characters allowed. */
  maxLength: _propTypes2.default.number,

  /** Maximum length of characters allowed. */
  minLength: _propTypes2.default.number,

  /** Input name. */
  name: _propTypes2.default.string.isRequired,

  /** onBlur callback. */
  onBlur: _propTypes2.default.func,

  /** onChange callback. Called with `cb(event, isValid)`. Check isValid to determine if the control is in error. */
  onChange: _propTypes2.default.func.isRequired,

  /** Function to call onFocus. */
  onFocus: _propTypes2.default.func,

  /** onKeyDown callback. */
  onKeyDown: _propTypes2.default.func,

  /** Placeholder to display when the field is empty. Defaults to "Enter &lt;label&gt;" when a placeholder isn't provided. Example: If the label is set to "Name", the placeholder will default to "Enter Name".  */
  placeholder: _propTypes2.default.string,

  /** Mark label with asterisk and perform required field validation on blur if set to true. */
  required: _propTypes2.default.bool,

  /** Input type. Accepts 'password', 'text', or 'textarea'. Need specialized masking or constraints? See the top of this page for a list of other specialized input components to consider.*/
  type: _propTypes2.default.oneOf(['password', 'text', 'textarea']),

  /** Text input value. */
  value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired,

  /** String to display as warning. Overrides standard error and warning handling. */
  warning: _propTypes2.default.string
};

TextInput.defaultProps = {
  addOnPosition: 'append',
  className: 'textInput',
  disabled: false,
  displayLabel: true,
  masking: {
    guide: false
  }
};

exports.default = TextInput;


//////////////////
// WEBPACK FOOTER
// ../fusion-ui-components/lib/TextInput/TextInput.js
// module id = 346
// module chunks = 2